<script>
  import { cubicInOut } from "svelte/easing";
  import { fly } from "svelte/transition";
  import { Button, Grid, GridContainer } from "@ObamaFoundation/of-design-system";
  import { getNextMonth } from "$lib/utilities/eventDate";

  export let selectedMonth = undefined;
  export let selectedFormat = undefined;

  const handleViewNextMonth = () => {
    selectedMonth = getNextMonth(selectedMonth);

    // Scroll to top of calendar
    setTimeout(() => {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    }, 10);
  };
</script>

<GridContainer containerClass={`${selectedFormat === "view-as-list" ? "lg:mt-15" : "mt-15"}`}>
  <Grid>
    <div
      class="col-full-width md:col-start-5 md:col-span-4"
      in:fly|global={{ duration: 500, ease: cubicInOut, y: 30, delay: 500 }}
      out:fly|global={{ duration: 500, ease: cubicInOut, y: -20, delay: 100 }}
    >
      <Button
        buttonClass="w-full lg:w-[400px] justify-center"
        variant="outline"
        label="View Next Month"
        on:click={handleViewNextMonth}
      />
    </div>
  </Grid>
</GridContainer>
